import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import SingleView from "../pages/ApmcDetailApplication/components/SingleFormView";
import { useSelector } from "react-redux";
import {
  getApmcOneTimeFormOneApplicationDetails,
  approveRejectApmcDetailApplication,
} from "../auth/services/privateapicalling";
import ApplicationTimelineModal from "../application/ApplicationTimeLineModal";
import { toast, ToastContainer } from "react-toastify";
import { label } from "yet-another-react-lightbox/*";
import MultiSelectCheckbox from "../application/MultiSelectCheckbox";

export const fieldsOptions = [
  { value: "registrationDate", label: "Registration Date" },
  // { value: "districtName", label: "District Name" },
  { value: "talukasName", label: "Talukas Name" },
  { value: "noOfVillagesmarket", label: "No Of Villages Market" },
  { value: "emailID", label: "Email ID" },
  { value: "chairmanName", label: "Chairman Name" },
  { value: "chairmanMobileNo", label: "Chairman Mobile No" },
  { value: "secreataryName", label: "Secreatary Name" },
  { value: "secreataryMobileNo", label: "Secreatary Mobile No" },
  { value: "noOfFarmerApmc", label: "No Of Farmer Apmc" },
  { value: "noOfTraderApmc", label: "No Of Trader Apmc" },
  { value: "noOfAgentsApmc", label: "No Of Agents Apmc" },
  { value: "noOfSocietesApmc", label: "No Of Societes Apmc" },
  { value: "lastElectionDate", label: "Last Election Date" },
  { value: "noOfunifiedLicense", label: "No Of unified License" },
  { value: "noOfgca", label: "No Of Gca" },
  { value: "totalApprovlStaff", label: "Total Approvl Staff" },
  { value: "totalRecruitStaff", label: "Total Recruit Staff" },
  { value: "noOfotherLicense", label: "No Of Other License" },
  { value: "lastAuditDate", label: "Last Audit Date" },
  {
    value: "detailsInfrastructureFacilities",
    label: "Details Infrastructure Facilities",
  },
  { value: "otherCommoditiesInApmc", label: "Other Commodities In Apmc" },
  { value: "mainYardDetails", label: "Main Yard Details" },
  { value: "subYardDetails", label: "Sub Yard Details" },
  {value:"isTradingFruitVeg", label:"Trading Vegetables Fruits"},
  {value:"apmcCanteenFacility",label:"Canteen facility in APMC"},
  {value:"apmcGuestHouse",label:"Guest house facility in APMC"},
  {value:"apmcPrivateLand",label:"Private Land of APMC"},
  {value:"apmcLeaseLand",label:"Leased Land of APMC"}
];
export const docOptions = [
  { value: "registrationDoc", label: "Registration Document" },
  { value: "electionResultDoc", label: "Election Result Document" },
  { value: "approvedStaffDoc", label: "Approved Staff Document" },
  { value: "lastAuditDoc", label: "Last Audit Document" },
  { value: "byeLawsDoc", label: "Bye Laws Document" },
];
const APMCPreviewDepartment = () => {
  const location = useLocation();
  const [applicationId, setApplicationID] = useState(
    location?.state?.applicationId
  );
  const [data, setData] = useState<any>({});
  const token = useSelector((state: any) => state.auth.token);
  const [isChecked, setIsChecked] = useState(false);
  const [comment, setComment] = useState("");
  const [buttonData, setButtonData] = useState([]);
  const [selectedDocId, setSelectedDocId] = React.useState<string | null>(null);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  const [checkboxError, setCheckboxError] = useState("");
  const [commentError, setCommentError] = useState("");
  const [transaction, setTransaction] = useState<any[]>([]);
  const language = useSelector((state: any) => state.auth.language);
  const [rejectedDocName, setRejectedDocName] = useState<any[]>([]);
  const [rejectedFields, setRejectedFields] = useState<any[]>([]);
  const [commentErrors, setCommentErrors] = useState<{ [key: string]: string }>(
    {}
  );
  const [fieldComments, setFieldComments] = useState<{ [key: string]: string }>(
    {}
  );
  const navigate = useNavigate();

  const handleCommentChange = (field: string, value: string) => {
    const updated = { ...fieldComments, [field]: value };
    setFieldComments(updated);

    setCommentErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[field];
      return newErrors;
    });

    const combinedComment = Object.entries(updated)
      .map(([field, value]) => `${field}: ${value}`)
      .join(", ");
    setComment(combinedComment);
  };
  // Helper function to get value from nested array structure
  const getFieldValue = (arr, fieldName) => {
    if (!arr || !Array.isArray(arr)) return null;
    const item = arr.find((item) => item.fieldName === fieldName);
    return item ? item.value : null;
  };

  const handleSelectionChange = (values: string[]) => {
    setRejectedFields(values);
  };

  const handleDocsSelectionChange = (values: string[]) => {
    const lowerCasedValues = values.map((value) => value.trim().toLowerCase());

    // Convert data object to array of key-value pairs
    const filteredDocs = Object.entries(data).filter(([docName, docId]) =>
      lowerCasedValues.includes(docName.trim().toLowerCase())
    );

    // Remove duplicates by document name (case-insensitive)
    const uniqueDocsMap = new Map();
    filteredDocs.forEach(([docName, docId]) => {
      const key = docName.trim().toLowerCase();
      if (!uniqueDocsMap.has(key)) {
        uniqueDocsMap.set(key, {
          docName: docName,
          docId: docId,
        });
      }
    });

    const uniqueDocs = Array.from(uniqueDocsMap.values());


    setRejectedDocName(uniqueDocs);
  };
  const fetchApplicationDetails = async (appId: any) => {
    try {
      //.log("fff");
      //.log("apppidddd", appId);
      const data = await getApmcOneTimeFormOneApplicationDetails(appId, token);
 
      setTransaction(data?.data?.ApmcDetailTransaction);
      setData(data?.data);
      setButtonData(data?.data?.buttonName);
  
    } catch (err) {
     
    } finally {
      //   setLoading(false);
      //.log("apppp", application);
    }
  };
  // Helper to render document link
  const renderDocument = (docId) => {
    if (!docId) return <span className="text-muted">Not uploaded</span>;
    return (
      <Link
        to="#"
        data-bs-toggle="modal"
        data-inert={true}
        data-bs-target="#apmc_modal"
        className="btn btn-outline-info align-items-center w-75"
        onClick={() => {
          setSelectedDocId(docId);
        }}
      >
        <i className="ti ti-eye"></i> View Document
      </Link>
    );
  };

  useEffect(() => {
    //.log("pppppppppp");

    //.log("param id", applicationId);

    fetchApplicationDetails(applicationId);
    // fetchTraderApplicationButton();
  }, []);

  const handleSubmit = async (btnStatus, appStatusLevel) => {

    if (data?.appStatusLevel !== "clerkAfterRejectionAction" ) {
      if (!isChecked && btnStatus!=="reject") {
        setCheckboxError("Please check the checkbox");
        return;
      } else {
        setCheckboxError("");
      }

      // Comment validation
      if (!comment.trim()) {
        setCommentError("Please enter a comment");
        return;
      } else {
        setCommentError("");
      }
    }

    if (
      roleIdentifier === "JC" &&
      data.appStatusLevel === "clerkAfterRejectionAction"
    ) {
      if (rejectedDocName.length === 0 && rejectedFields.length === 0) {
        toast.error("Please select at least one rejected document or field");
        return;
      }
    }
    const errors: { [key: string]: string } = {};
  
    // Check for minimum 5 words in comments for rejected documents
    rejectedDocName.forEach((doc) => {
      const comment = fieldComments[doc.docName];
      if (!comment || comment.trim() === "") {
        errors[doc.docName] = "Comment is required.";
      }
    });

    // Check for minimum 5 words in comments for rejected fields
    const missingComments = rejectedFields.filter((fieldKey) => {
      const comment = fieldComments[fieldKey];
      return !comment || comment.trim() === "";
    });

    if (missingComments.length > 0 || Object.keys(errors).length > 0) {
      // Set errors for missing or short comments
      missingComments.forEach((fieldKey) => {
        const comment = fieldComments[fieldKey];
        setCommentErrors((prevErrors) => ({
          ...prevErrors,
          [fieldKey]:
            !comment || comment.trim() === "" ? "Comment is required." : null,
        }));
      });

      // Set errors for rejected documents
      rejectedDocName.forEach((doc) => {
        const comment = fieldComments[doc.docName];
        if (!comment || comment.trim() === "") {
          errors[doc.docName] = "Comment is required.";
        }
      });

      // Update the comment errors state
      setCommentErrors((prevErrors) => ({
        ...prevErrors,
        ...errors,
      }));

      // alert("Please provide comments for all selected fields.");
      return null; // Return early after setting errors for both
    }
   
    const payload = {
      applicationId: applicationId,
      status: btnStatus,
      appStatusLevel: appStatusLevel,
      comment: comment,
      rejectedDocName: rejectedDocName,
      rejectedFieldName: rejectedFields,
    };
    try {
      const response = await approveRejectApmcDetailApplication(token, payload);
      if (response?.success) {
        let successMessage = "Form submitted successfully";
      
      if (btnStatus === "reject") {
        successMessage = "Query raised successfully";
      } else if (btnStatus === "approve") {
        successMessage = "Application approved successfully";
      }
      
      toast.success(successMessage);
        setTimeout(() => {
          navigate("/pending-one-time");
        }, 1000);
      }
    } catch (error) {
  
    }
  };

  return (
    <>
      <div className="page-wrapper p-3 mt-5">
        <div className="page-header">
          <div className="row">
            <div className="col">
              <h3 className="page-title">{language.track_app} </h3>
            </div>
          </div>
        </div>
        <div className="d-flex flex-column text-nightblue align-items-center justify-content-center">
          <div
            id="table"
            className="w-100 overflow-hidden border bg-white border-secondary rounded mb-5"
          >
            <div
              id="head"
              className="d-flex w-100 rounded-top border-bottom border-secondary"
              style={{ backgroundColor: "#CCE3FF" }}
            >
              <h4 className="col-1 d-flex justify-content-center align-items-center">
                S.No.
              </h4>
              <h4 className="col-6 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary">
                પ્રશ્ન(Field)
              </h4>
              <h4 className="col-5 p-2 justify-content-center d-flex align-items-center">
                જવાબ(Response)
              </h4>
            </div>

            {/* Field 01 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                01.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  બજાર સમિતિની નોંધણી(Registration of the Market Committee)
                </p>
              </div>

              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="d-flex gap-2 w-75">
                  <div className="d-flex flex-column w-50">
                    {renderDocument(data?.registrationDoc)}
                  </div>
                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Date</small>
                    <strong>{data?.registrationDate}</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* Field 02 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                02.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  તમારા જિલ્લો અને તાલુકા પસંદ કરો(Select your District and
                  talukas)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>District: </strong>
                  {data?.districtName}
                </div>

                <div className="w-75 bg-light p-2 rounded border">
                  <strong>Talukas: </strong>
                  {data?.talukasName?.join(", ")}
                </div>
              </div>
            </div>

            {/* Field 03 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                03.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  બજાર વિસ્તારમાં આવતા ગામોની સંખ્યા.(Number of villages falling
                  within market area)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfVillagesmarket}</strong>
                </div>
              </div>
            </div>

            {/* Field 04 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                04.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">ઇ-મેલ આઇડી(Email ID)*</p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.emailID}</strong>
                </div>
              </div>
            </div>

            {/* Field 05 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                05.
              </h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  ચેરમેન/સેક્રેટરીનું નામ અને મોબાઇલ નંબર (Name & Mobile Number
                  of Chairman/Secretary)
                </p>
              </div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                {/* Chairman row */}
                <div className="d-flex gap-2 w-75">
                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Chairman Name</small>
                    <strong>{data?.chairmanName}</strong>
                  </div>

                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Mobile Number</small>
                    <strong>{data?.chairmanMobileNo}</strong>
                  </div>
                </div>

                {/* Secretary row */}
                <div className="d-flex gap-2 w-75">
                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Secretary Name</small>
                    <strong>{data?.secreataryName}</strong>
                  </div>

                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Mobile Number</small>
                    <strong>{data?.secreataryMobileNo}</strong>
                  </div>
                </div>
              </div>
            </div>

            {/* Field 06 - Multiple sub-fields */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                06.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં ખેડૂતોની સંખ્યા(Number of
                  farmers covered under the jurisdiction of the Market
                  Committee)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfFarmerApmc}</strong>
                </div>
              </div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં વેપારીઓની સંખ્યા(Number of
                  traders coming under the purview of the market committee)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfTraderApmc}</strong>
                </div>
              </div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં કમિશન એજન્ટોની
                  સંખ્યા(Number of commission agents coming under the purview of
                  the Market Committee)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfAgentsApmc}</strong>
                </div>
              </div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  બજાર સમિતિના કાર્યક્ષેત્રમાં આવતાં સહકારી ખરીદ વેચાણ મંડળીઓની
                  સંખ્યા.(Number of cooperative purchase and sale societies
                  falling under the purview of the market committee.)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfSocietesApmc}</strong>
                </div>
              </div>
            </div>

            {/* Field 07 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                07.
              </h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  નવા ચૂંટણી બાદ APMCની પ્રથમ સામાન્ય બેઠકની તારીખ (Date of the
                  First General meeting of APMC after fresh election)*
                </p>
              </div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                <div className="d-flex gap-2 w-75">
                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Date</small>
                    <strong>{data?.lastElectionDate}</strong>
                  </div>

                  <div className="d-flex flex-column w-50">
                    {renderDocument(data?.electionResultDoc)}
                  </div>
                </div>
              </div>
            </div>

            {/* Field 08 - License Details */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                08.
              </h4>
              <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  લાઇસન્સ ધારક વેપારીઓની વિગતો (કુલ)(Details of license-holding
                  traders (Total)):
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">યુનિફાઇડ લાયસન્સ(Unified License)</p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfunifiedLicense}</strong>
                </div>
              </div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  જનરલ કમિશન એજન્ટ્સ(General commission agents)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfgca}</strong>
                </div>
              </div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">અન્ય લાયસન્સ(Other License)</p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>{data?.noOfotherLicense}</strong>
                </div>
              </div>
            </div>

            {/* Field 09 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                09.
              </h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  છેલ્લી ઓડિટની તારીખ દાખલ કરો અને ઓડિટ રિપોર્ટ અપલોડ કરો.
                  (Enter the last audit date and upload the audit report)*
                </p>
              </div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                <div className="d-flex gap-2 w-75">
                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Last Audit Date</small>
                    <strong>{data?.lastAuditDate}</strong>
                  </div>

                  <div className="d-flex flex-column w-50">
                    {renderDocument(data?.lastAuditDoc)}
                  </div>
                </div>
              </div>
            </div>

            {/* Field 10 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                10.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">APMC ના પેટા કાયદા(bye laws of APMC)*</p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">{renderDocument(data?.byeLawsDoc)}</div>
              </div>
            </div>

            {/* Field 11 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                11.
              </h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  મુખ્યયાર્ડ-સરનામા સાથે (Main yard with address)*
                </p>
              </div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                {data?.mainYardDetails &&
                  data?.mainYardDetails.map((yard, index) => (
                    <div
                      key={index}
                      className="w-75 border rounded p-3 bg-light"
                    >
                      <div className="d-flex flex-column gap-2">
                        <div>
                          <small className="text-muted">Name</small>
                          <div>
                            <strong>{yard?.name}</strong>
                          </div>
                        </div>

                        <div className="d-flex gap-2">
                          <div className="w-50">
                            <small className="text-muted">Date</small>
                            <div>
                              <strong>{yard?.date}</strong>
                            </div>
                          </div>

                          <div className="w-50">
                            <small className="text-muted">Address</small>
                            <div>
                              <strong>{yard?.address}</strong>
                            </div>
                          </div>
                        </div>

                        <div>{renderDocument(yard?.doc)}</div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            {/* Field 12 - Multiple Sub Yards */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                12.
              </h4>

              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  સબયાર્ડ-સરનામા સાથે (Sub yards with address)*
                </p>
              </div>

              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                {data?.subYardDetails &&
                  data?.subYardDetails.map((subYard, index) => (
                    <div
                      key={index}
                      className="w-100 border rounded p-3 bg-light"
                    >
                      <div className="mb-2">
                        <strong>Sub Yard {index + 1}</strong>
                      </div>

                      <div className="d-flex flex-column gap-2">
                        <div>
                          <small className="text-muted">Name</small>
                          <div>
                            <strong>{subYard?.name}</strong>
                          </div>
                        </div>

                        <div className="d-flex gap-2">
                          <div className="w-50">
                            <small className="text-muted">Date</small>
                            <div>
                              <strong>{subYard?.date}</strong>
                            </div>
                          </div>

                          <div className="w-50">
                            <small className="text-muted">Address</small>
                            <div>
                              <strong>{subYard?.address}</strong>
                            </div>
                          </div>
                        </div>

                        <div>{renderDocument(subYard?.doc)}</div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>

            {/* Field 13 */}
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                13.
              </h4>
              <div className="col-6 border-start border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">વિવિધ વિગતો (Miscellaneous details)</p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center"></div>
            </div>

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  શાકભાજી અને ફળોની વેપાર પ્રવૃત્તિ થાય છે કે નહીં?(Trading in
                  Vegetables & Fruits)
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75">
                  <strong>
                    {getFieldValue(
                      data?.isTradingFruitVeg,
                      "isfruitvegetable"
                    ) === "yes"
                      ? "Yes"
                      : "No"}
                  </strong>
                </div>
              </div>
            </div>

            {getFieldValue(data?.isTradingFruitVeg, "isfruitvegetable") ===
              "yes" && (
              <div className="d-flex border-bottom border-secondary">
                <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>

                <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-center p-2"></div>

                <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                  {/* Vegetables */}
                  <div className="w-100 d-flex flex-column align-items-center gap-2">
                    <p className="m-0 fw-bold">શાકભાજી (Vegetables)</p>
                    <div className="w-75 bg-light p-2 rounded border">
                      {Array.isArray(
                        getFieldValue(data?.isTradingFruitVeg, "vegetables")
                      )
                        ? getFieldValue(
                            data?.isTradingFruitVeg,
                            "vegetables"
                          ).join(", ")
                        : getFieldValue(data?.isTradingFruitVeg, "vegetables")}
                    </div>
                  </div>

                  {/* Fruits */}
                  <div className="w-100 d-flex flex-column align-items-center gap-2">
                    <p className="m-0 fw-bold">ફળો (Fruits)</p>
                    <div className="w-75 bg-light p-2 rounded border">
                      {Array.isArray(
                        getFieldValue(data?.isTradingFruitVeg, "fruits")
                      )
                        ? getFieldValue(data?.isTradingFruitVeg, "fruits").join(
                            ", "
                          )
                        : getFieldValue(data?.isTradingFruitVeg, "fruits")}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center"></h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  એપીએમસીમાં અન્ય કયા માલ-વસ્તુઓનું વેપાર થાય છે?(Other
                  commodities traded in APMC)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>{data?.otherCommoditiesInApmc?.join(", ")}</strong>
                </div>
              </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                14.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  મંજૂર સ્ટાફની વિગતો અને સંબંધિત દસ્તાવેજો(Details of approved
                  staff and related documents)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="d-flex gap-2 w-75">
                  <div className="d-flex flex-column w-50">
                    {renderDocument(data?.approvedStaffDoc)}
                  </div>
                  <div className="d-flex flex-column w-50">
                    <small className="text-muted">Total Approved Staff</small>
                    <strong>{data?.totalApprovlStaff}</strong>
                  </div>
                </div>
                <div className="w-75 mt-2">
                  <small className="text-muted">Total Recruited Staff</small>
                  <div>
                    <strong>{data?.totalRecruitStaff}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                15.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  APMC કૅન્ટીન સુવિધા(Canteen facility in APMC)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>
                    {getFieldValue(data?.apmcCanteenFacility, "hasCanteen") ===
                    "yes"
                      ? `Yes, Seating Capacity: ${getFieldValue(
                          data?.apmcCanteenFacility,
                          "seatingCapacity"
                        )}`
                      : "No"}
                  </strong>
                </div>
              </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                16.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  APMC ગેસ્ટ હાઉસ સુવિધા(Guest house facility in APMC)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>
                    {getFieldValue(data?.apmcGuestHouse, "hasGuestRoom") ===
                    "yes"
                      ? `Yes, Bed Capacity: ${getFieldValue(
                          data?.apmcGuestHouse,
                          "bedCapacity"
                        )}`
                      : "No"}
                  </strong>
                </div>
              </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                17.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  ઇન્ફ્રાસ્ટ્રક્ચર સુવિધાઓની વિગતો (Details of infrastructure
                  facilities)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-2 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>
                    {data?.detailsInfrastructureFacilities
                      ?.map((facility) => facility.value)
                      .join(", ")}
                  </strong>
                </div>
              </div>
            </div>
            <div className="d-flex border-bottom border-secondary">
              <h4 className="col-1 d-flex align-items-center justify-content-center">
                18.
              </h4>
              <div className="col-6 border-start border-end border-secondary d-flex align-items-center justify-content-start p-2">
                <p className="p-2">
                  APMC ની ખાનગી જમીન અને ભાડે લેવામાં આવેલી જમીનની વિગતો
                  (Details of private and leased land of APMC)*
                </p>
              </div>
              <div className="col-5 d-flex flex-column p-2 gap-3 align-items-center justify-content-center">
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>
                    {getFieldValue(data?.apmcPrivateLand, "hasPrivateLand") ===
                    "yes"
                      ? `Private Land - Yes, Hectare: ${getFieldValue(
                          data?.apmcPrivateLand,
                          "hectare"
                        )}, Area: ${getFieldValue(
                          data?.apmcPrivateLand,
                          "area"
                        )}, Sq Meter: ${getFieldValue(
                          data?.apmcPrivateLand,
                          "sqmeter"
                        )}`
                      : "Private Land - No"}
                  </strong>
                </div>
                <div className="w-75 bg-light p-2 rounded border">
                  <strong>
                    {getFieldValue(data?.apmcLeaseLand, "hasPrivateLand") ===
                    "yes"
                      ? `Leased Land - Yes, Hectare: ${getFieldValue(
                          data?.apmcLeaseLand,
                          "hectare"
                        )}, Area: ${getFieldValue(
                          data?.apmcLeaseLand,
                          "area"
                        )}, Sq Meter: ${getFieldValue(
                          data?.apmcLeaseLand,
                          "sqmeter"
                        )}, Lease Period: ${getFieldValue(
                          data?.apmcLeaseLand,
                          "leasePeriod"
                        )} years`
                      : "Leased Land - No"}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
        {(roleIdentifier === "JC" || roleIdentifier === "COM") && (
          <div>
            {transaction && transaction.length > 0 && (
              <Link
                to="#"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#comment_modal"
                className="d-flex btn btn-primary align-items-center w-25 mb-4"
              >
                <i className="me-2 ti ti-file-description" />
                {language.view_comment}
              </Link>
            )}

            {roleIdentifier == "JC" &&
              data?.appStatusLevel == "clerkAfterRejectionAction" && (
                <div>
                  <div className="mb-4">
                    <h3 className="text-danger fs-12 page-title">
                      {language.rej_da}
                    </h3>
                    <MultiSelectCheckbox
                      Options={fieldsOptions}
                      onChange={handleSelectionChange}
                    />
                    {rejectedFields &&
                      rejectedFields.length > 0 &&
                      rejectedFields.map((fieldKey) => (
                        <div key={fieldKey} className="mb-3">
                          <label className="form-label">
                            {
                              fieldsOptions.find((f) => f.value === fieldKey)
                                ?.label
                            }{" "}
                            Comment{" "}
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              commentErrors[fieldKey] ? "is-invalid" : ""
                            }`}
                            value={fieldComments[fieldKey] || ""}
                            onChange={(e) =>
                              handleCommentChange(fieldKey, e.target.value)
                            }
                            placeholder={`Enter comment `}
                          />
                          {commentErrors[fieldKey] && (
                            <div className="invalid-feedback">
                              {commentErrors[fieldKey]}
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                  <div className="mb-4">
                    <h3 className="text-danger fs-12 page-title">
                      {language.rej_doc}
                    </h3>

                    <MultiSelectCheckbox
                      Options={docOptions}
                      onChange={handleDocsSelectionChange}
                    />
                    {rejectedDocName &&
                      rejectedDocName.length > 0 &&
                      rejectedDocName.map((fieldKey) => (
                        <div key={fieldKey?.docName} className="mb-3">
                          <label className="form-label">
                            {
                              docOptions.find(
                                (f) => f.value === fieldKey?.docName
                              )?.label
                            }{" "}
                            Comment
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              commentErrors[fieldKey.docName]
                                ? "is-invalid"
                                : ""
                            }`}
                            value={fieldComments[fieldKey.docName] || ""}
                            onChange={(e) =>
                              handleCommentChange(
                                fieldKey.docName,
                                e.target.value
                              )
                            }
                            placeholder={`Enter comment `}
                          />
                          {commentErrors[fieldKey.docName] && (
                            <div className="invalid-feedback">
                              {commentErrors[fieldKey.docName]}
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )}

            {[
              "pendingAtDClerk",
              "pendingAtClerkResubmission",
              "pendingAtCo",
              "pendingAtCoResubmission",
            ].includes(data?.appStatusLevel) &&
              data?.role === roleIdentifier && (
                <div>
                  <div className="pb-3">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        id="declaration"
                        className="form-check-input"
                        checked={isChecked}
                        onChange={() => {
                          setIsChecked(!isChecked);
                          setCheckboxError("");
                        }}
                      />
                      <label
                        htmlFor="declaration"
                        className="form-check-label fw-bold"
                      >
                        I hereby confirm that I have reviewed all the details
                        and that the information has been correctly filled in
                        the report. I approve this for further processing.
                      </label>
                    </div>

                    {checkboxError && (
                      <p className="error text-danger">{checkboxError}</p>
                    )}
                  </div>

                  <div className="pb-3">
                    <textarea
                      className="form-control pb-3"
                      placeholder="Enter your comment"
                      name="currAt"
                      value={comment}
                      onChange={(e) => {
                        setComment(e.target.value);
                        setCommentError("");
                      }}
                      rows={4}
                    />
                    {commentError && (
                      <p className="error text-danger">{commentError}</p>
                    )}
                  </div>
                </div>
              )}

            {buttonData && (
              <div className="d-flex gap-2">
                {buttonData.map((button) => (
                  <button
                    key={button.status}
                    className={`btn ${
                      button.status === "reject"
                        ? "btn-danger"
                        : button.status === "permanentReject"
                        ? "btn-secondary"
                        : "btn-success"
                    } h-10 w-30`}
                    onClick={() =>
                      handleSubmit(button.status, button.appStatusLevel)
                    }
                  >
                    {button.buttonLabel}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      <SingleView docId={selectedDocId} />
      <ApplicationTimelineModal comments={transaction} />
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};
export default APMCPreviewDepartment;
